export const FILTERING_DATE_OPTIONS = [
  { label: "Today", value: "Today" },
  { label: "Week", value: "Week" },
  { label: "Month", value: "Month" },
  { label: "Year", value: "Year" },
];
